import { useBooleanFlagValue } from "@openfeature/react-sdk";
export function useKubernetesWorkerOutOfEarlyAccess() {
    return useBooleanFlagValue("kubernetes-worker-out-of-early-access", false);
}
